import { nullishToOptional } from "../helpers";
import { z } from "zod";
export const UserOnboardingDepartment = z.enum([
    "Design",
    "Engineering",
    "Product",
    "Brand",
    "Other",
]);
export const UserOnboardingJobLevel = z.enum([
    "Executive",
    "Manager",
    "IndividualContributor",
    "Other",
]);
const userThemePresets = [
    "Custom",
    "Default",
    "HighContrast",
    "DefaultDark",
    "HighContrastDark",
    "SpaceBlue",
    "DarkGrey",
    "SystemPreference",
    "Sepia",
];
const portalThemePresets = [...userThemePresets, "DefaultPortal"];
export const PortalThemePreset = z.enum(portalThemePresets);
export const UserThemePreset = z.enum(userThemePresets);
export const BaseTheme = z.object({
    backgroundColor: z.string().optional(),
    accentColor: z.string().optional(),
    contrast: z.number().min(16).max(100).optional(),
    isSecondaryEnabled: z.boolean().optional(),
    secondaryBackgroundColor: z.string().optional(),
    secondaryContrast: z.number().min(16).max(100).optional(),
    isEditorWhite: z.boolean().optional(),
});
export const UserTheme = BaseTheme.extend({
    preset: UserThemePreset.optional(),
});
export const PortalTheme = BaseTheme.extend({
    preset: PortalThemePreset.optional(),
});
export const UserOnboarding = z.object({
    companyName: z.string().optional(),
    numberOfPeopleInOrg: z.string().optional(),
    numberOfPeopleInDesignTeam: z.string().optional(),
    department: UserOnboardingDepartment.optional(),
    jobTitle: z.string().optional(),
    phase: z.string().optional(),
    jobLevel: UserOnboardingJobLevel.optional(),
    designSystemName: z.string().optional(),
    defaultDestination: z.string().optional(),
    figmaUrl: z.string().optional(),
    isPageDraftOnboardingFinished: z.boolean().optional(),
    isApprovalsOnboardingFinished: z.boolean().optional(),
});
export const UserProfile = z.object({
    name: z.string(),
    avatar: nullishToOptional(z.string()),
    nickname: nullishToOptional(z.string()),
    onboarding: nullishToOptional(UserOnboarding),
    theme: nullishToOptional(UserTheme),
    portalTheme: nullishToOptional(PortalTheme),
});
